<template>
    <div class="popular-product bg-light rounded py-5" style="width: 95%;" data-aos="fade-down" data-aos-duration="500" data-aos-easing="ease-in-sine">
        <div class="container">
            <div class="row">

                <div class="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0" v-for="(key) in (1,3)">
                    <div class="product-item-sm d-flex">
                        <div class="thumbnail text-center">
                            <img :src="data['url_'+key]" alt="" class="img-fluid">
                        </div>
                        <div class="pt-3 align-self-center">
                            <h3>{{data['tittle '+key]}}</h3>
                            <p>{{data['content_'+key]}}</p>
                            <!-- <p><a href="#">Read More</a></p> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        data(){
            return{
                data:[],
            }
        },
        mounted(){
            const GuaranteeRef = ref(database, 'Guarantee/');
            onValue(GuaranteeRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
            });
        }
    }
</script>